const communicationsState = {
  etc: {
    selectedPlatform: null,
  },
};

export default communicationsState;
